
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class EventsSheetsLayout extends Vue {
    @Prop() loading!: boolean;
}
